export default __webpack_public_path__ + "static/Milan-Logo-Blue-4e6f080e8dbe7fe7d1a1008cd94b73a4.webp";